import React, { useState } from "react";
import { Modal, Form, Button, Message, Segment, Grid } from "semantic-ui-react";
import { Formik } from "formik";
import * as Yup from "yup";
import axios from "../../../../../../../apis/dvdlocator";

const CreateInventory = ({ onClose, upc }) => {
  const [isSuccess, setIsSuccess] = useState(false);
  const [showPrompt, setShowPrompt] = useState(true);
  const [showForm, setShowForm] = useState(false);

  const validationSchema = Yup.object({
    inventory_title: Yup.string().required("Inventory title is required"),
    inventory_shelf: Yup.string().required("Inventory shelf is required"),
    inv: Yup.number()
      .nullable()
      .transform((value) => (isNaN(value) ? null : value))
      .test(
        "is-valid-number",
        "If provided, inventory quantity must be a positive whole number",
        (value) => value === null || (value > 0 && Number.isInteger(value))
      ),
  });

  const initialValues = {
    inventory_title: "",
    inventory_shelf: "",
    inv: null,
  };

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    try {
      // API request will go here
      const response = await axios.post("/inventory", values);

      const inventoryId = response.data.id;

      await axios.put(`/supply/${upc}`, { inventory_id: inventoryId });

      resetForm();
      setIsSuccess(true);
    } catch (error) {
      console.error("Error creating inventory:", error);
    } finally {
      setSubmitting(false);
    }
  };

  const handleCreateInventory = () => {
    setShowPrompt(false);
    setShowForm(true);
  };

  return (
    <Modal open={true} onClose={onClose} size="small">
      <Modal.Header>
        {showPrompt ? "Create Inventory" : "Create New Inventory"}
      </Modal.Header>
      <Modal.Content>
        {showPrompt && (
          <Segment textAlign="center" padded>
            <p>
              No inventory record associated with this supply unit. Would you
              like to create one?
            </p>
            <Grid>
              <Grid.Row columns={2}>
                <Grid.Column textAlign="center">
                  <Button onClick={onClose}>Cancel</Button>
                </Grid.Column>
                <Grid.Column textAlign="center">
                  <Button primary onClick={handleCreateInventory}>
                    Yes
                  </Button>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Segment>
        )}

        {isSuccess && (
          <Segment textAlign="center" padded>
            <Message positive>
              <Message.Header>Inventory Created Successfully</Message.Header>
              <p>Your new inventory has been created.</p>
            </Message>
            <Button primary onClick={onClose}>
              Close
            </Button>
          </Segment>
        )}

        {showForm && !isSuccess && (
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              isSubmitting,
              setFieldValue,
            }) => (
              <Form onSubmit={handleSubmit}>
                <Form.Field>
                  <label>Inventory Title</label>
                  <Form.Input
                    name="inventory_title"
                    placeholder="Enter inventory title"
                    value={values.inventory_title}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={
                      touched.inventory_title && errors.inventory_title
                        ? {
                            content: errors.inventory_title,
                            pointing: "below",
                          }
                        : null
                    }
                  />
                </Form.Field>
                <Form.Field>
                  <label>Inventory Shelf</label>
                  <Form.Input
                    name="inventory_shelf"
                    placeholder="Enter shelf location"
                    value={values.inventory_shelf}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={
                      touched.inventory_shelf && errors.inventory_shelf
                        ? {
                            content: errors.inventory_shelf,
                            pointing: "below",
                          }
                        : null
                    }
                  />
                </Form.Field>
                <Form.Field>
                  <label>Inventory Quantity (Optional)</label>
                  <Form.Input
                    name="inv"
                    type="number"
                    min="1"
                    step="1"
                    placeholder="Enter inventory quantity (optional)"
                    value={values.inv === null ? "" : values.inv}
                    onChange={(e, { value }) => {
                      const numValue = value === "" ? null : Number(value);
                      setFieldValue("inv", numValue);
                    }}
                    onBlur={handleBlur}
                    error={
                      touched.inv && errors.inv
                        ? {
                            content: errors.inv,
                            pointing: "below",
                          }
                        : null
                    }
                  />
                </Form.Field>
                <Grid>
                  <Grid.Row>
                    <Grid.Column width={16}>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <Button type="button" onClick={onClose}>
                          Cancel
                        </Button>
                        <Button
                          type="submit"
                          primary
                          loading={isSubmitting}
                          disabled={isSubmitting}
                        >
                          Create
                        </Button>
                      </div>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </Form>
            )}
          </Formik>
        )}
      </Modal.Content>
    </Modal>
  );
};

export default CreateInventory;
